import React from 'react'
import {Card, CardHeader, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Row, Col } from 'reactstrap'
import classnames from 'classnames'

const PAGE_SIZE = 12

export default class SeoCarClasses extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // How many of the (up to 96) all-cars cards are visible. The rest stay in the DOM
            // (display:none) so crawlers read every car; "View more" reveals the next PAGE_SIZE.
            visibleCount: PAGE_SIZE
        }
    }

    showMore(e) {
        e.preventDefault()
        this.setState({ visibleCount: this.state.visibleCount + PAGE_SIZE })
    }

    renderAllCars() {
        const cars = this.props.all_cars || []
        if (!cars.length) return null
        const { visibleCount } = this.state
        return (
            <TabPane tabId="all_cars">
                <Row>
                    <Col className="text-center p-3" style={{minHeight: 105}}>{this.props.text_all_cars}</Col>
                </Row>
                <Row>
                    {cars.map((c, i) =>
                        <Col sm="3" key={`car_${c.car_model.id}`} style={i < visibleCount ? undefined : {display: 'none'}}>
                            <Card className="mb-4 car-small-card">
                                <CardHeader className="small text-truncate bg-white" tag="h3">
                                    {c.car_model.name} {this.props.text_similar}
                                </CardHeader>
                                <CardBody>
                                    <a href={c.car_model.url || '#top'}>
                                        <img src={c.car_model.image} className="img-fluid" alt={c.car_model.alt} loading="lazy" decoding="async" />
                                    </a>
                                    <div className="d-flex justify-content-between align-items-end mt-2">
                                        <img src={c.provider.logo} className="provider-logo-small" alt={c.provider.alt} />
                                        <div className="price text-right">{c.small_price}</div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    )}
                </Row>
                {visibleCount < cars.length &&
                    <div className="text-center mb-3">
                        <button type="button" className="btn btn-primary btn-small" onClick={(e) => this.showMore(e)}>
                            {this.props.view_more}
                        </button>
                    </div>
                }
                <div className='font-size-90'>
                    <i className="fa fa-info-circle text-primary mr-1" />
                    {this.props.text_below_car_model_cards}{' '}
                    {this.props.text_link_below_car_model_cards}.
                </div>
                <div className="text-right">
                    <a href="#" onClick={(e) => { e.preventDefault(); window.dispatchEvent(new CustomEvent('toggleModal')) }}>{this.props.text_all_cars_link}</a>
                </div>
            </TabPane>
        )
    }

    render() {
        const classLinks = this.props.class_links || []
        return (
            <Card className="mb-4">
                <CardBody>
                    <Nav tabs>
                        <NavItem key="tab_all_cars">
                            <NavLink href="#" className={classnames({ active: true })} onClick={(e) => e.preventDefault()}>
                                {this.props.text_all_cars_tab}
                            </NavLink>
                        </NavItem>
                        {classLinks.map((cl, i) =>
                            <NavItem key={`tab_class_${i}`}>
                                <NavLink href={cl.href}>{cl.tab}</NavLink>
                            </NavItem>
                        )}
                    </Nav>
                    <TabContent activeTab="all_cars">
                        {this.props.template == 'car_classes' && this.renderAllCars()}
                    </TabContent>
                </CardBody>
            </Card>
        )
    }
}
